// extracted by mini-css-extract-plugin
export default {"parameters":"styles_parameters__okZ4e","state":"styles_state__re4Kp","title":"styles_title__FzD0G","desc":"styles_desc__zF7nP","buttons":"styles_buttons__FMXFm"};